var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsapp_svg2__a",
    x1: 224.9,
    x2: -9.4,
    y1: -35,
    y2: 218.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#whatsapp_svg2__a",
    id: "whatsapp_svg2__b",
    x1: 224.5,
    x2: -9.7,
    y1: -35.3,
    y2: 217.9
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 0C44.9 0 0 44.9 0 100s5.2 37.1 15.1 52.9c-3.9 13.8-11.1 40-11.2 40.3-.4 1.4 0 2.8 1 3.8s2.5 1.3 3.8.9l39.6-12.2c15.5 9.4 33.3 14.3 51.5 14.3 55.1 0 100-44.9 100-100S155.1 0 100 0m0 192.3c-17.4 0-34.3-4.9-49-14-.6-.4-1.3-.6-2-.6s-.8 0-1.1.2l-34.6 10.7c2.5-9.3 7.1-25.9 9.8-35.1.3-1.1.1-2.2-.5-3.2a91.93 91.93 0 0 1-14.9-50.2c0-51 41.4-92.4 92.3-92.4s92.3 41.4 92.3 92.3-41.4 92.3-92.3 92.3",
    style: {
      fill: "url(#whatsapp_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.3 123.6c-7.1-3.9-13.1-7.9-17.6-10.8-3.4-2.2-5.8-3.8-7.6-4.7-5-2.5-8.8-.7-10.2.7-.2.2-.3.4-.5.6-5.2 7.8-11.9 15.2-13.9 15.6-2.3-.4-13-6.4-23.6-15.3C81 100.6 74.2 92 73.2 86.1c7-7.2 9.5-11.7 9.5-16.8S70.3 41.9 68.1 39.7s-7.3-2.6-15-1c-.7.1-1.4.5-2 1-.9.9-22.8 23.2-12.4 50.3 11.4 29.7 40.7 64.1 78 69.7 4.2.6 8.2 1 11.9 1 22 0 34.9-11.1 38.6-33 .3-1.6-.5-3.2-1.9-4ZM117.9 152c-39.5-5.9-64.3-45-72-64.9-7.6-19.7 6.4-37.3 9.9-41.2 2.9-.5 5.9-.7 7.1-.5C65.5 49 74.6 66.2 75 69.3c0 2-.7 4.8-8.5 12.7-.7.7-1.1 1.7-1.1 2.7 0 20.1 42.5 48.1 50 48.1s15.1-11 19.9-18.2c.3 0 .8.1 1.4.4 1.4.7 3.8 2.3 6.8 4.2 4 2.6 9.3 6.1 15.6 9.7-2.9 13.7-10.8 27.6-41.3 23Z",
    style: {
      strokeWidth: 0,
      fill: "url(#whatsapp_svg2__b)"
    }
  }));
};
export default SvgWhatsapp;